
import React from "react";
import './vision.css'
const Vision = () => { 
  return (
    <div  id = "vision-page" className='dark'>
     <div id = "nav-placeholder" />
      <div id="container">
        <div className="section">
          <h1>
           VISION
          </h1>
         <p> 1.To create a culture that embodies a deep drive of learning and encourages creativity and excellence 
        </p>
        <p>   2. To consistently build innovative and intelligent machines capable of performing all their tasks in an efficient fashion.
        </p>
        <p>  3. To create machines with a strong underlying influence of ethics and develop practices of  environmentally sustainable construction and creations.
         </p>
          </div>
        </div>
      </div>
  );
};
  
export default Vision;


